import TablePage from '@/found/components/table_page';
import Form from './form/index';

export default {
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {

    };
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'view') {
        this.formName = 'Form';
        this.modalConfig.title = '详情';
        this.formConfig = {
          code: val.code,
          row,
        };
        this.openFull();
      }
    },
  },
  created() {
    this.getConfigList('renovation_costs');
  },
};
